// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"415":"d66f702a","932":"80cf7c4d"}[chunkId] + ".css";
};